// Acciones de estado y su confirmación para las promos de venta y de referido, en el formato común.
import {
    LIFECYCLE_ACTION_ICON,
    type LifecycleAction,
    type LifecycleConfirmation,
} from '@/shared/patterns/Lifecycle';
import type { SalePromotionListItem, SalePromotionTransition } from '../api/promotionsContract';
import { ACTION_COPY } from '../lib/promotionActionsCopy';
import { availableActions } from '../lib/promotionStatus';
import { PROMOTIONS_PERMISSIONS } from '../permissions';

const ACTION_ICON: Record<SalePromotionTransition, keyof typeof LIFECYCLE_ACTION_ICON> = {
    PUBLISH: 'publish',
    PAUSE: 'pause',
    RESUME: 'resume',
    EXPIRE: 'expire',
    ARCHIVE: 'archive',
};

/** Las acciones que admite el estado de la promo; una apagada lleva su motivo en la etiqueta. */
export function promotionLifecycleActions(
    promotion: SalePromotionListItem,
    now: Date,
    onAction: (transition: SalePromotionTransition) => void,
): LifecycleAction[] {
    return availableActions(promotion, now).map((option) => ({
        key: option.transition,
        label: option.disabledReason ? `${option.label} (${option.disabledReason})` : option.label,
        primary: option.transition === 'PUBLISH',
        destructive: option.destructive,
        disabled: option.disabledReason !== undefined,
        icon: LIFECYCLE_ACTION_ICON[ACTION_ICON[option.transition]],
        permission: PROMOTIONS_PERMISSIONS.update,
        onSelect: () => {
            onAction(option.transition);
        },
    }));
}

/** La confirmación de un cambio de estado; `null` si la acción va directa. */
export function statusConfirmation(
    promotion: Pick<SalePromotionListItem, 'name'>,
    transition: SalePromotionTransition,
): LifecycleConfirmation | null {
    const confirm = ACTION_COPY[transition].confirm;
    if (!confirm) return null;
    return {
        title: confirm.title(promotion.name),
        description: confirm.description,
        confirmLabel: confirm.confirmLabel,
        destructive: confirm.destructive,
    };
}
